import React, {Component} from 'react';
import converter from 'number-to-words';
import $ from 'jquery';
import moment from 'moment';
import {num, Title, Noun, UnCurrency, SubjectVerb, Pronoun} from '../../../../model/Helper';
import PaperSignatories from '../../../../view/PaperSignatories';
import PaperSignatoriesAcknowledgement from '../../../../view/PaperSignatoriesAcknowledgement';
import PaperParty from '../../../../view/PaperParty';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				if(this.isVisible(".header")){
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
        });
        
    }
    
    componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
    }

    render() {

        let p = this.props.details.property;
        let s = this.props.details.mortgagor;
        let b = this.props.details.mortgagee;
        //let pa = this.props.details.payment;

        /**
         * Noun / Pronoun
         */
        let nounMortgagor = Noun(s, "mortgagor");
        let nounMortgagee  = Noun(b, "mortgagee");

        let blankLine = blank_line;

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;
        let pType = blankLine;
        if(p.type==="Condominium"){
            pType = `condominium`;
        }
        if(p.type==="Land"){
            pType = `parcel of land`;
        }
        if(p.type==="Land with Improvement"){
            pType = `parcel of land, together with its improvement`;
        }

        let registryOfDeeds = p.registryOfDeeds ? p.registryOfDeeds : blankLine;
        let loanAmount = p.loanAmount ? UnCurrency(p.loanAmount) : blankLine;
        let loanAmountText = (typeof parseFloat(loanAmount) === "number" && parseFloat(loanAmount)>0) ?
        converter.toWords(loanAmount) : 
        blankLine;
        let loanAmountNumber = num(loanAmount);
        let loanInterestBasis = p.loanInterestBasis ? p.loanInterestBasis : blankLine;
        let loanInterestRate = p.loanInterestRate ? p.loanInterestRate : blankLine;
        let loanInterestRateText = (typeof parseFloat(loanInterestRate) === "number" && parseFloat(loanInterestRate)>0) ?
        converter.toWords(loanInterestRate) : 
        blankLine;
        let loanDuration = p.loanDuration ? p.loanDuration : blankLine;
        let loanDurationInMonthsNumber = num(loanDuration*12);
        
        let loanDurationInMonthsText = (typeof parseFloat(loanDurationInMonthsNumber) === "number" && parseFloat(loanDurationInMonthsNumber)>0) ?
        converter.toWords(loanDurationInMonthsNumber) : 
        blankLine;

        //let registrationType = p.registrationType ? p.registrationType : blankLine;
        let registerMortgageBy = p.registerMortgageBy ? p.registerMortgageBy : blankLine;
        let requireFireInsurance = p.requireFireInsurance;
        let registerMortgage = p.registerMortgage;
        let paymentFees = p.paymentFees;
        let paymentDefault = p.paymentDefault;
        let paymentDefaultText = (typeof parseFloat(paymentDefault) === "number" && parseFloat(paymentDefault)>0) ?
        converter.toWords(paymentDefault) : 
        blankLine;

        let sectionDeduct = (requireFireInsurance==="Yes" ? 1 : 0) + (registerMortgage==="Yes" ? 1 : 0);
        console.log("Hello", sectionDeduct);

        // Natural person variables
        let mortgagorName = [], 
            mortgagorSpouseName = [],
            mortgagorNationality = [],
            mortgagorAddress = [],
            mortgagorRepresentativeName = [],
            mortgagorRepresentativeNationality = [],
            mortgagorRepresentativeAddress = [],
            mortgagorTin = [];
        // Corporation variables
        let mortgagorCorporationName = [],
            mortgagorCorporationPrincipalPlaceOfBusiness = [],
            mortgagorCorporationRepresentativeName = [],
            //mortgagorCorporationRepresentativePosition = [],
            mortgagorCorporationTin = [];
        this.props.details.mortgagor.forEach((mortgagor, i)=>{
            mortgagorName[i] = (mortgagor.mortgagorFname || mortgagor.mortgagorMname || mortgagor.mortgagorLname) ? 
                                    (mortgagor.mortgagorFname+(mortgagor.mortgagorMname?` ${mortgagor.mortgagorMname}`:"")+(mortgagor.mortgagorLname?` ${mortgagor.mortgagorLname}`:"")+(mortgagor.mortgagorSuffix?` ${mortgagor.mortgagorSuffix}`:"")): 
                                    blankLine;
            mortgagorSpouseName[i] = (mortgagor.mortgagorSpouseFname || mortgagor.mortgagorSpouseMname || mortgagor.mortgagorSpouseLname) ? 
            (mortgagor.mortgagorSpouseFname+(mortgagor.mortgagorSpouseMname?` ${mortgagor.mortgagorSpouseMname}`:"")+(mortgagor.mortgagorSpouseLname?` ${mortgagor.mortgagorSpouseLname}`:"")+(mortgagor.mortgagorSpouseSuffix?` ${mortgagor.mortgagorSpouseSuffix}`:"")): 
            blankLine;
            mortgagorNationality[i] = mortgagor.mortgagorNationality ? mortgagor.mortgagorNationality : blankLine;
            mortgagorAddress[i] = mortgagor.mortgagorAddress ? mortgagor.mortgagorAddress :  blankLine;
            
            mortgagorRepresentativeName[i] = (mortgagor.mortgagorRepresentativeFname || mortgagor.mortgagorRepresentativeMname || mortgagor.mortgagorRepresentativeLname) ? 
                                    (mortgagor.mortgagorRepresentativeFname+(mortgagor.mortgagorRepresentativeMname?` ${mortgagor.mortgagorRepresentativeMname}`:"")+(mortgagor.mortgagorRepresentativeLname?` ${mortgagor.mortgagorRepresentativeLname}`:"")+(mortgagor.mortgagorRepresentativeSuffix?` ${mortgagor.mortgagorRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgagorRepresentativeNationality[i] = mortgagor.mortgagorRepresentativeNationality ? mortgagor.mortgagorRepresentativeNationality : blankLine;
            mortgagorRepresentativeAddress[i] = mortgagor.mortgagorRepresentativeAddress ? mortgagor.mortgagorRepresentativeAddress :  blankLine;
            mortgagorTin[i] = mortgagor.mortgagorTin ? mortgagor.mortgagorTin : "";

            mortgagorCorporationName[i] = mortgagor.mortgagorCorporationName ? mortgagor.mortgagorCorporationName : blankLine;
            mortgagorCorporationPrincipalPlaceOfBusiness[i] = mortgagor.mortgagorCorporationPrincipalPlaceOfBusiness ? mortgagor.mortgagorCorporationPrincipalPlaceOfBusiness : blankLine;
            
            mortgagorCorporationRepresentativeName[i] = (mortgagor.mortgagorCorporationRepresentativeFname || mortgagor.mortgagorCorporationRepresentativeMname || mortgagor.mortgagorCorporationRepresentativeLname) ? 
                                    (mortgagor.mortgagorCorporationRepresentativeFname+(mortgagor.mortgagorCorporationRepresentativeMname?` ${mortgagor.mortgagorCorporationRepresentativeMname}`:"")+(mortgagor.mortgagorCorporationRepresentativeLname?` ${mortgagor.mortgagorCorporationRepresentativeLname}`:"")+(mortgagor.mortgagorCorporationRepresentativeSuffix?` ${mortgagor.mortgagorCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgagorCorporationTin[i] = mortgagor.mortgagorCorporationTin ? mortgagor.mortgagorCorporationTin : "";
        });

        // Natural person variables
        let mortgageeName = [], 
            mortgageeSpouseName = [],
            mortgageeNationality = [],
            mortgageeAddress = [],
            mortgageeRepresentativeName = [],
            mortgageeRepresentativeNationality = [],
            mortgageeRepresentativeAddress = [],
            mortgageeTin = [];
        // Corporation variables
        let mortgageeCorporationName = [],
            mortgageeCorporationPrincipalPlaceOfBusiness = [],
            mortgageeCorporationRepresentativeName = [];
        this.props.details.mortgagee.forEach((mortgagee, i)=>{
            mortgageeName[i] = (mortgagee.mortgageeFname || mortgagee.mortgageeMname || mortgagee.mortgageeLname) ? 
                                    (mortgagee.mortgageeFname+(mortgagee.mortgageeMname?` ${mortgagee.mortgageeMname}`:"")+(mortgagee.mortgageeLname?` ${mortgagee.mortgageeLname}`:"")+(mortgagee.mortgageeSuffix?` ${mortgagee.mortgageeSuffix}`:"")): 
                                    blankLine;
            mortgageeSpouseName[i] = (mortgagee.mortgageeSpouseFname || mortgagee.mortgageeSpouseMname || mortgagee.mortgageeSpouseLname) ? 
            (mortgagee.mortgageeSpouseFname+(mortgagee.mortgageeSpouseMname?` ${mortgagee.mortgageeSpouseMname}`:"")+(mortgagee.mortgageeSpouseLname?` ${mortgagee.mortgageeSpouseLname}`:"")+(mortgagee.mortgageeSpouseSuffix?` ${mortgagee.mortgageeSpouseSuffix}`:"")): 
            blankLine;
            mortgageeNationality[i] = mortgagee.mortgageeNationality ? mortgagee.mortgageeNationality : blankLine;
            mortgageeAddress[i] = mortgagee.mortgageeAddress ? mortgagee.mortgageeAddress :  blankLine;
            
            mortgageeRepresentativeName[i] = (mortgagee.mortgageeRepresentativeFname || mortgagee.mortgageeRepresentativeMname || mortgagee.mortgageeRepresentativeLname) ? 
                                    (mortgagee.mortgageeRepresentativeFname+(mortgagee.mortgageeRepresentativeMname?` ${mortgagee.mortgageeRepresentativeMname}`:"")+(mortgagee.mortgageeRepresentativeLname?` ${mortgagee.mortgageeRepresentativeLname}`:"")+(mortgagee.mortgageeRepresentativeSuffix?` ${mortgagee.mortgageeRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgageeRepresentativeNationality[i] = mortgagee.mortgageeRepresentativeNationality ? mortgagee.mortgageeRepresentativeNationality : blankLine;
            mortgageeRepresentativeAddress[i] = mortgagee.mortgageeRepresentativeAddress ? mortgagee.mortgageeRepresentativeAddress :  blankLine;

            mortgageeCorporationName[i] = mortgagee.mortgageeCorporationName ? mortgagee.mortgageeCorporationName : blankLine;
            mortgageeCorporationPrincipalPlaceOfBusiness[i] = mortgagee.mortgageeCorporationPrincipalPlaceOfBusiness ? mortgagee.mortgageeCorporationPrincipalPlaceOfBusiness : blankLine;
            
            mortgageeCorporationRepresentativeName[i] = (mortgagee.mortgageeCorporationRepresentativeFname || mortgagee.mortgageeCorporationRepresentativeMname || mortgagee.mortgageeCorporationRepresentativeLname) ? 
                                    (mortgagee.mortgageeCorporationRepresentativeFname+(mortgagee.mortgageeCorporationRepresentativeMname?` ${mortgagee.mortgageeCorporationRepresentativeMname}`:"")+(mortgagee.mortgageeCorporationRepresentativeLname?` ${mortgagee.mortgageeCorporationRepresentativeLname}`:"")+(mortgagee.mortgageeCorporationRepresentativeSuffix?` ${mortgagee.mortgageeCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgageeTin[i] = mortgagee.mortgageeTin ? mortgagee.mortgageeTin : "";   
        });

        // Create this into array so we can use map inside JSX
        let scheduleOfPaymentsDates = [];
        for(let i=0; i<p.monthsToPayBalance; i++) {
            scheduleOfPaymentsDates.push({
                "count": i,
                "amort": (p.price-p.downpayment-p.earnestMoneyAmount)/p.monthsToPayBalance,
                "date": `${moment(p.firstInstallmentDue).add(i, 'month').format('LL')}`
            })
        }

        let surrenderCondominium = [];
        let surrenderLand = [];
        let surrenderLandWithImprovement = [];
        if(p.type){
            if(p.type==="Condominium"){
                if(p.surrenderCct==="Yes"){
                    surrenderCondominium.push(`Owner’s Duplicate Original Copy of CCT ${p.ctn};`);
                }
                if(p.surrenderLatestTaxDeclarationOnCondominium==="Yes"){
                    surrenderCondominium.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderTaxClearanceCertificate==="Yes"){
                    surrenderCondominium.push(`Tax Clearance Certificate`);
                }
            }
            if(p.type==="Land"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLand.push(`Owner’s Duplicate Original Copy of OCT ${p.oct};`);
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLand.push(`Owner’s Duplicate Original Copy of TCT ${p.tct};`);
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLand.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLand.push(`Tax Clearance Certificate for the land;`);
                }
            }
            if(p.type==="Land with Improvement"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLandWithImprovement.push(`Owner’s Duplicate Original Copy of OCT ${p.oct};`);
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLandWithImprovement.push(`Owner’s Duplicate Original Copy of TCT ${p.tct};`);
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLandWithImprovement.push(`Latest Tax Declaration on the land;`);
                }
                if(p.surrenderLatestTaxDeclarationOnImprovment==="Yes"){
                    surrenderLandWithImprovement.push(`Latest Tax Declaration on the improvement;`);
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLandWithImprovement.push(`Tax Clearance Certificate for the land;`);
                }
                if(p.surrenderTaxClearanceCertificateOnImprovement==="Yes"){
                    surrenderLandWithImprovement.push(`Tax Clearance Certificate on the improvement`);
                }
            }
        }

        return (
            <div className="preview">
                <div className="default-preview-fade top"></div>
                <div className="top-preview">
                    <div className="text-center">
                        <p>Preview</p>
                    </div>

                    <div className="paper">
                    <div className="paper-inner">
                        
                        <div className="paper-title text-center">
							Real Estate Mortgage
						</div>

                        <div className="text-uppercase">
                            <p className="no-indent">
                                KNOW ALL MEN BY THESE PRESENTS:
                            </p>
                        </div>

                        <div>
                            <p>
                                This Real Estate Mortgage (hereinafter "REM"), is made and entered into by and between:
                            </p>
                        </div>

                        <PaperParty party={s} type="mortgagor" />

                        <div className="paper-narrow my-3 text-center">
                            <div className="my-3">- and -</div>
                        </div>

                        <PaperParty party={b} type="mortgagee" />

                        <div className="paper-narrow my-3 text-center">
                            <p><strong>WITNESSETH</strong>: That-</p>
                        </div>

                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounMortgagor}</span> are the absolute and registered owners of a <span className="dynamic-data property_type">{pType}</span> (hereinafter “Subject Real Property”), situated at <span className="dynamic-data property_address text-capitalize">{pAddress}</span> and covered by <span className="dynamic-data text-uppercase property_ctn property_registrationType property_tct property_oct">{title}</span> of the Registry of Deeds for <span className="dynamic-data property_registryOfDeeds text-capitalize">{registryOfDeeds}</span>.
                            </p>
                        </div>
                                
                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounMortgagor}</span> is indebted to the <span className="text-uppercase">{nounMortgagee}</span> in the principal sum of <span className="dynamic-data text-uppercase">{loanAmountText}</span> PESOS (P<span className="dynamic-data property_loanAmount">{loanAmountNumber}</span>), Philippine Currency, under and by virtue of a Promissory Note (hereinafter “Note”) attached herewith and made an integral part hereof;   
                            </p>
                        </div>

                        <div>
                            <p>
                                WHEREAS, the <span className="text-uppercase">{nounMortgagor}</span> {SubjectVerb(nounMortgagor, "has")} agreed to secure the payment of the Note to the <span className="text-uppercase">{nounMortgagee}</span> by means of a good and valid mortgage upon the Subject Real Property as described in <span className="dynamic-data text-uppercase">{title}</span>, a copy of which is hereto attached and made an integral part hereof;  
                            </p>
                        </div>

                        <div>
                            <p>
                                NOW THEREFORE, for and in consideration of the foregoing premises and as security for payment of the aforesaid obligation, the <span className="text-uppercase">{nounMortgagor}</span> {SubjectVerb(nounMortgagor, "has")} transferred and conveyed, and by these presents transfer and convey by way of MORTGAGE, unto the <span className="text-uppercase">{nounMortgagee}</span>, {Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} heirs, successors or assigns the aforesaid Subject Real Property under the terms and conditions specified below:
                            </p>
                        </div>

                        <div className="section1 my-3">
                            <h5 className="my-3">SECTION 1. <u>PAYMENT AND INTEREST</u></h5>
                            <p>
                                The principal obligation secured by this mortgage shall be <span className="dynamic-data text-uppercase">{loanAmountText}</span> PESOS (P<span className="dynamic-data">{loanAmountNumber}</span>), plus interest of <span className="dynamic-data text-uppercase">{loanInterestRateText}</span> percent (<span className="dynamic-data property_loanInterestRate">{loanInterestRate}%</span>) per <span className="dynamic-data property_loanInterestBasis">{loanInterestBasis==="Monthly"?`month`:`year`}</span> on the principal, for a duration of <span className="dynamic-data">{loanDurationInMonthsText}</span> (<span className="dynamic-data property_loanDuration">{loanDurationInMonthsNumber}</span>) months; the particulars of this loan obligation are described on the Note hereto attached.
                            </p> 
                        </div>

                        <div className="section2 my-3">
                            <h5 className="my-3">SECTION 2. <u>TAXES AND ASSESSMENT</u></h5>
                            <p>
                                The <span className="text-uppercase">{nounMortgagor}</span> shall, when due, pay to the government the real property taxes and such special assessments, if any, that may be levied on the mortgaged property, presenting to the <span className="text-uppercase">{nounMortgagee}</span> upon demand the receipt or evidence of payment; and in case of delinquency on the part of said <span className="text-uppercase">{nounMortgagor}</span>, the <span className="text-uppercase">{nounMortgagee}</span> may at {Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} option pay all such taxes and penalties, provided that the amount so paid shall be charged against the <span className="text-uppercase">{nounMortgagor}</span> with legal interest thereon, and the same shall be deemed to be guaranteed likewise by the present mortgage.
                            </p>
                        </div>

                        <div className="section3 my-3">
                            <h5 className="my-3">SECTION 3. <u>REPAIRS AND PRESERVATION</u></h5>
                            <p>
                                That, with a view to preserving the condition of the buildings and improvements covered by this mortgage, the <span className="text-uppercase">{nounMortgagor}</span> agrees to undertake the necessary repairs thereon, when so required by the <span className="text-uppercase">{nounMortgagee}</span>, the latter reserving the right to inspect personally or through representative the premises from time to time to verify the existing conditions.
                            </p>
                        </div>
                                
                        {/** Conditional section */}
                        <span className="property_requireFireInsurance"></span>
                        <div className={requireFireInsurance==="Yes"?``:`d-none`}>
                            <div className="section4 my-3">
                                <h5 className="my-3">SECTION 4. <u>INSURANCE</u></h5>
                                <p>
                                    The <span className="text-uppercase">{nounMortgagor}</span> binds himself to insure the improvements covered by this mortgage against fire with a reputable insurance company acceptable to the <span className="text-uppercase">{nounMortgagee}</span> for a sum of not less than the principal obligation herein secured, endorsing the corresponding insurance policy in favor of the <span className="text-uppercase">{nounMortgagee}</span> to the extent of the latter’s interest; provided, however, that in case of failure on the part of the <span className="text-uppercase">{nounMortgagor}</span> to pay in due time the insurance premium, the <span className="text-uppercase">{nounMortgagee}</span> reserves the right to effect payment and charge the amount against the <span className="text-uppercase">{nounMortgagor}</span> with legal interest thereon, and this obligation shall be deemed to be also guaranteed by the present mortgage.
                                </p>
                            </div>
                        </div>
                        
                        {/** Conditional section */}
                        <span className="property_registerMortgage"></span>
                        <div className={registerMortgage==="Yes"?``:`d-none`}>
                            <div className="section5 my-3">
                                <h5 className="my-3">SECTION 5. <u>REGISTRATION</u></h5>
                                <p>
                                    This REM shall be registered before the Office of the Register of Deeds for the purpose of having the same annotated on the title of the Subject Real Property. The fee for its registration shall be for the account of the <span className="dynamic-data text-uppercase property_registerMortgageBy">{registerMortgageBy}</span>.
                                </p>    
                            </div>
                        </div>

                        <div className="section6 my-3">
                            <h5 className="my-3">SECTION {4 + sectionDeduct}. <u>OTHER INCIDENTAL EXPENSES</u></h5>
                            <p>
                                The cost of documentary stamps, including the notarial fee and other expenses in connection with the preparation of this REM and such other legal document as may be required shall be for the account of the <span className="dynamic-data text-uppercase property_paymentFees">{paymentFees}</span>.
                            </p>    
                        </div>

                        <div className="section7 my-3">
                            <h5 className="my-3">SECTION {5 + sectionDeduct}. <u>POSSESSION OF THE OWNER'S DUPLICATE ORIGINAL TITLE</u></h5>
                            <p>
                                Upon execution of this REM, the <span className="text-uppercase">{nounMortgagor}</span> shall surrender possession of the Owner’s Duplicate Original Title in favor of the <span className="text-uppercase">{nounMortgagee}</span>. The same shall only be given back upon discharge of the mortgage.
                            </p>    
                        </div>

                        <div className="section8 my-3">
                            <h5 className="my-3">SECTION {6 + sectionDeduct}. <u>BREACH OF CONTRACT</u></h5>
                            <p>
                                Any violation on the part of the <span className="text-uppercase">{nounMortgagor}</span> of any of the conditions herein stipulated, including the non-payment when due of any stipulated amortizations, or the interest on the principal obligation, for <span className="dynamic-data property_paymentDefault">{paymentDefaultText} ({paymentDefault})</span> consecutive months, shall be deemed sufficient ground for the immediate foreclosure of this mortgage to recover the whole amount when remaining unpaid and outstanding, the period hereinabove stipulated notwithstanding.    
                            </p>    
                        </div>

                        <div className="section9 my-3">
                            <h5 className="my-3">SECTION {7 + sectionDeduct}. <u>SPECIAL POWER OF ATTORNEY</u></h5>
                            <p>
                                In case of foreclosure, the <span className="text-uppercase">{nounMortgagee}</span> may elect to proceed either judicially or extrajudicially, and in the latter event, it shall be, as it is hereby appointed attorney-infact of the <span className="text-uppercase">{nounMortgagor}</span> with irrevocable powers, among other things, to take possession of the mortgaged property, to collect the fruits and rents therefrom, and to sell the mortgaged property at public auction in accordance with the procedure described in Act 3135, as amended by Act 4118, for the satisfaction of all the obligations secured by this mortgage, including reasonable attorney’s fees for the enforcement thereof and liquidated damages in an amount equivalent to ten percent (10%) of all such obligations as may then be due and outstanding, but in no case to be less than ONE HUNDRED THOUSAND PESOS (P100,000.00), apart from cost and legal expenses prescribed by the Rules of Court; as in case of judicial foreclosure, the <span className="text-uppercase">{nounMortgagee}</span>, shall be entitled as a matter of right to the appointment of a receiver of the mortgaged property, with the necessary authority appertaining to such position.   
                            </p>    
                        </div>

                        <div className="section10 my-3">
                            <h5 className="my-3">SECTION {8 + sectionDeduct}. <u>BIDDER AT PUBLIC AUCTION</u></h5>
                            <p>
                                The <span className="text-uppercase">{nounMortgagee}</span> or {Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} representative may participate as bidder at the auction sale of the mortgaged property, whether under judicial foreclosure proceedings or under the special power of sale herein provided, or otherwise:  
                            </p>    
                            <ol type="a">
                                <li>
                                    To the payment of expenses and cost of foreclosure sale, including publication, and attorney’s fees as herein provided, as well as liquidated damages;
                                </li>
                                <li>
                                    To the satisfaction of all interest and charges accruing upon the obligations herein secured;
                                </li>
                                <li>
                                    To the satisfaction of the amount of the principal obligation secured by the mortgage;
                                </li>
                                <li>
                                    To the satisfaction of all further obligations owing by the <span className="text-uppercase">{nounMortgagor}</span> or other lienholders; and
                                </li>
                                <li>
                                    The residue, if any, to be turned over to the <span className="text-uppercase">{nounMortgagor}</span>.
                                </li>
                            </ol>
                        </div>

                        <div className="section11 my-3">
                            <h5 className="my-3">SECTION {9 + sectionDeduct}. <u>DISCHARGE OF MORTGAGE</u></h5>
                            <p>
                                It is the principal condition of this mortgage that if the <span className="text-uppercase">{nounMortgagor}</span> shall pay or cause to be paid to the <span className="text-uppercase">{nounMortgagee}</span> or {Pronoun("his", s[0].mortgagorGender, s[0].legalPersonality, nounMortgagor)} heirs or assigns, the principal obligation herein secured, together with the interest thereon, and the other obligations arising thereunder, when the same shall have become due and payable, and shall comply faithfully with all the other conditions stipulated herein, then this mortgage shall <span className="font-italic">ipso facto</span> become null and void; otherwise, it shall remain in full force and effect and be enforceable in the manner provided by law and by this agreement.
                            </p>
                        </div>

                        <br />
                        <br />

                        <div>
                            <p>
                            IN WITNESS WHEREOF, the parties have hereunto set their hands this _______________ at _______________.
                            </p>
                        </div>

                        <br />
                        <br />

                        <PaperSignatories party1={s} party2={b} />
                        
                        <br /><br />
                        <hr />
                        <br /><br />
                        
                        {
                        /**
                         * Acknowledgement section
                         */
                        }
                        <div className="paper-top-left d-inline-block">
							<div>REPUBLIC OF THE PHILIPPINES )</div>
							<div>)S.S.</div>
						</div>

                        <div className="paper-title text-center">
							Acknowledgement
						</div>

                        <div>
                            <p>
                                BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                            </p>
                        </div>

                        <PaperSignatoriesAcknowledgement party1={s} party2={b} />

                        <div>
                            <p>
                                Known to me and to me known to be the same persons who executed the foregoing Real Estate Mortgage (REM) consisting of <span className="dynamic-data"><small className="text-muted font-italic">[to be filled up by the system]</small></span> pages, including this page where the acknowledgment is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                            </p>
                            <p>
                                WITNESS MY HAND AND SEAL in the place and on the date first above written.   
                            </p>
                        </div>

                        <br />
                        <br />
                        <div className="docno">
							Doc No. ________; <br />
							Page No. _______; <br />
							Book No. _______; <br />
							Series of 20 ___. <br />
						</div>

                    </div>
                    </div> {/** End of paper */}

                </div>

                <div className="default-preview-fade"></div>
            </div>
        );
    }

}

export default Preview;



// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/real-estate-mortgage/Preview.js